import { gql } from '@apollo/client';


export const GET_CUSTOMER_DETAILS = gql`
  query GetCustomerDetails($id: ID, $companyId:ID) {
  getCustomerDetails(_id: $id, companyId: $companyId) {
          _id
          company
          name
          facebookSenderId
          facebookPageId
          platform
          assignedOperator {
            date
            userId {
              _id
              name
              email
            }
          }
          latestConversationId {
            message
            timestamp
          }
          followUpDate
          priority
          isConversationClosed
          assignedTo
  }
}
`;